export const topLevelEvents = [
  "CONVERSATION_L2_QUESTION_GENERATED",
  "CONVERSATION_FIRST_L2_MESSAGE_GENERATED",
  "FORM_PUBLISHED",
  "CONVERSATION_NEXT_MESSAGE_GENERATED",
];

export const CURRENT_ENVIRONMENT = "CURRENT_ENVIRONMENT";
